<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Add Note"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="noteForm">
        <v-row class="mt-3">
          <v-col cols="12">
            <v-textarea
              name="input-notes"
              label="Write a note"
              v-model="notes"
              rows="4"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="handleSaveTodoNote"
          >
            Add
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { ButtonsSubmitForm } from '@/components/buttons'
import { DynamicModal } from '@/components/dialogs'

export default {
  props: [
    'todoIdIn'
  ],
  components: {
    DynamicModal,
    ButtonsSubmitForm
  },
  data: () => ({
    showModalProp: false,
    isFormValid: false,
    editForm: false,
    nameRules: [
      v => !!v || 'This field is required',
      v => (v && v.length <= 250) || 'This field must be less than 250 characters'
    ]
  }),
  computed: {
    ...mapFields('todoNote', [
      'todoId',
      'notes'
    ])
  },
  methods: {
    ...mapActions('todoNote', [
      'saveTodoNote',
      'clearTodoNote'
    ]),
    handleSaveTodoNote () {
      this.todoId = this.todoIdIn
      if (this.$refs.noteForm.validate()) {
        this.saveTodoNote()
          .then(() => this.closeModal())
      }
    },
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.$emit('savedNote')
    }
  },
  created () {
    this.clearTodoNote()
  }
}
</script>
